import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient, APIMessageResponse } from '@/shared/services/apiConfig';

// SendAccount Usage Email
export const useSendAccountUsagesReport = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ months }: { months: string | undefined }) => {
      return await apiClient.post<APIMessageResponse>(
        `/api/v1/usages/send-report`,
        { params: { months } }
      );
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['usages-send-report', variables?.months] });
    },
    onError: (error: Error) => {
      return error;
    },
  });
};